/* @flow */

import * as React from 'react';
import classNames from 'classnames';

import styles from './TextArea.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

const useStyles = createUseThemeStyles(styles);

type Props = {
  className: string,
  value: string,
  defaultValue: string,
  onChange: (e: SyntheticEvent<HTMLTextAreaElement>) => void,
  onFocus?: () => void,
  onBlur?: () => void,
  isHighlighted?: boolean,
  isMinified?: boolean,
  hasError?: boolean,
};

const TextArea = ({
  className,
  isHighlighted,
  isMinified,
  value,
  defaultValue,
  onChange,
  onFocus,
  onBlur,
  hasError,
  ...rest
}: Props): React.Node => {
  /*
   |------------------------------------------------------------------------------
   | Classes
   |------------------------------------------------------------------------------
   */

  const classes = useStyles();

  const rootClasses = classNames(className, {
    [classes['root-isHighlighted']]: isHighlighted,
    [classes['root-isRegular']]: !isMinified,
    [classes['root-hasError']]: hasError,
  });

  /*
    |------------------------------------------------------------------------------
    | Elements
    |------------------------------------------------------------------------------
    */

  return (
    <textarea
      {...rest}
      value={value || defaultValue}
      className={rootClasses}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};

export default React.memo<Props>(TextArea);
